module.exports = __webpack_public_path__ + "static/img/6.47789d6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/6.jpeg
// module id = k8dx
// module chunks = 3